import { PureComponent, ReactNode } from 'react';
import AntSelect, { OptionTypeBaseObj } from '../AntSelect';
import { Element } from './types';
import { EkaFocosableElement } from '../../../../../common/types/EkaFocusable';

interface Props {
    index: number;
    element: Element;
    setValue: (ref: string, option?: OptionTypeBaseObj) => void;
    handleNextFocus: (index: number, subIndex: number) => void;
    setPropertyInputRef: (ref: EkaFocosableElement | null, index: number, subIndex: number) => void;
}

class SelectInput extends PureComponent<Props> {
    render(): ReactNode {
        const { index, element, setValue, handleNextFocus, setPropertyInputRef } = this.props;
        const { ref, label, settings } = element;
        const { options } = settings;
        const valueSelectsOptions = options?.map((item) => ({
            id: item.value.toString(),
            value: item.label,
        }));
        const defaultValue = settings.defaultValue;
        const defaultOption = options?.find((i) => i.value === defaultValue);

        return (
            <div className="flex items-center justify-between space-x-16">
                <p>{label}</p>
                <div className="flex items-center justify-end w-40p text-darwin-neutral-600 rounded-4 cursor-pointer">
                    <AntSelect
                        className="text-darwin-neutral-600 w-full"
                        showArrow={true}
                        customDropdownWidth={180}
                        allowClear={false}
                        placeholder={defaultOption?.label || '-- Select an option --'}
                        optionFilterProp="children"
                        options={valueSelectsOptions || []}
                        setRef={(ref) => setPropertyInputRef(ref, index, 0)}
                        setValue={(option) => {
                            setValue(ref, option);
                            handleNextFocus(index + 1, 0);
                        }}
                        filterOption={true}
                        value={
                            valueSelectsOptions?.find(
                                (opt) => defaultValue?.toString() === opt.id,
                            ) || undefined
                        }
                        getValue={(o) => o.id}
                        getLabelToCompare={(o) => o.value}
                    />
                </div>
            </div>
        );
    }
}

export default SelectInput;
